import React from "react";
import { Box } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body } from "../../../components/Typography";

export const OrderDetailsTab: React.FC = () => {
  return (
    <Box sx={{ padding: tokens.spacing[4] }}>
      <Body>Order Details</Body>
    </Box>
  );
};
